// FIXME: change to '../API' when we update to webpack2. If we do this now all
// files from API modules will be included in external_api.js.
import { PostMessageTransportBackend, Transport } from '@vietmeet/js-utils/transport';
import { getVietMeetGlobalNS } from '../../react/features/base/util/helpers';
import { API_ID } from '../API/constants';
export { PostMessageTransportBackend, Transport };
/**
 * Option for the default low level transport.
 *
 * @type {Object}
 */
const postisOptions = {};
if (typeof API_ID === 'number') {
    // @ts-ignore
    postisOptions.scope = `vietmeet_external_api_${API_ID}`;
}
/**
 * The instance of Transport class that will be used by VietMeet Meet.
 *
 * @type {Transport}
 */
// @ts-ignore
let transport;
/**
 * Returns the instance of Transport class that will be used by VietMeet Meet.
 *
 * @returns {Transport}
 */
export function getVietMeetTransport() {
    // @ts-ignore
    if (!transport) {
        transport = new Transport({ backend: new PostMessageTransportBackend({ postisOptions }) });
    }
    return transport;
}
/**
 * Sets the transport to passed transport.
 *
 * @param {Object} externalTransportBackend - The new transport.
 * @returns {void}
 */
// @ts-ignore
getVietMeetGlobalNS().setExternalTransportBackend = externalTransportBackend => 
// @ts-ignore
transport.setBackend(externalTransportBackend);
